import React, { useEffect } from 'react';
import { View, Text, StyleSheet, ActivityIndicator } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useRouter, useLocalSearchParams } from 'expo-router';
import * as WebBrowser from 'expo-web-browser';

export default function WebViewScreen() {
  const router = useRouter();
  const { url, title } = useLocalSearchParams<{ url: string; title: string }>();

  useEffect(() => {
    const openBrowser = async () => {
      try {
        const targetUrl = url || 'https://www.padrinho.app/';
        console.log('Opening URL:', targetUrl);
        
        // Open in system browser or in-app browser tab
        const result = await WebBrowser.openBrowserAsync(targetUrl, {
          dismissButtonStyle: 'close',
          presentationStyle: WebBrowser.WebBrowserPresentationStyle.CURRENT_CONTEXT,
          controlsColor: '#7E7D75',
          toolbarColor: '#FFFFFF',
        });

        console.log('WebBrowser result:', result);
        
        // Navigate back after browser is closed
        router.back();
      } catch (error) {
        console.error('Error opening browser:', error);
        console.error('URL was:', url);
        router.back();
      }
    };

    if (url) {
      openBrowser();
    } else {
      console.error('No URL provided to webview');
      router.back();
    }
  }, [url, router]);

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color="#7E7D75" />
        <Text style={styles.loadingText}>Abrindo {title || 'página'}...</Text>
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#ffffff',
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#ffffff',
  },
  loadingText: {
    marginTop: 16,
    fontSize: 16,
    fontFamily: 'Inter_400Regular',
    color: '#7E7D75',
    textAlign: 'center',
  },
});